import type { LegalStaleDoc } from '@signalvote/api-client';

/**
 * Send a user who owes a re-consent to the accept screen, with the stale list in the URL. A full
 * page nav so it works from anywhere (query mutations, imperative fetches) without router context.
 */
export function redirectToLegalAccept(stale: LegalStaleDoc[]): void {
  // Guard against the loop if we're already there.
  if (window.location.pathname === '/legal/accept') return;
  const search = new URLSearchParams({ stale: JSON.stringify(stale) });
  window.location.href = `/legal/accept?${search.toString()}`;
}
